var window=global;var $CLJS=require("./cljs_env.js");
'use strict';var Kga=require("moment-timezone");module.exports=Kga;